import {
  createDomainApi,
  type ExtractEntityType,
  type ExtractInputType,
} from '@skylabs-digital/react-proto-kit';
import { apiKeyInputSchema, apiKeySchema } from '../schemas/apiKey.schema';

export const apiKeysApi = createDomainApi('api-keys', apiKeySchema, apiKeyInputSchema);

export type ApiKeyEntity = ExtractEntityType<typeof apiKeysApi>;
export type ApiKeyInputType = ExtractInputType<typeof apiKeysApi>;
